import React from 'react'
import { useLocation } from 'react-router-dom'
import FooterItem from './item'
import AddFundSpeedDial from './addFundSpeedDial'
interface IFooterProps {
    menus: Array<IMenu>
}
interface IMenu {
    title: string
    icon: string
    activeIcon: string
    route: string
    isMain?: boolean
    main: boolean
    role: string
}

const Footer = ({ menus }: IFooterProps) => {
    const { pathname } = useLocation()
    const isFund: boolean = pathname.includes('funds')
    return (
        <>
            {isFund && <AddFundSpeedDial />}
            <div className="md:px-[35%] md:bg-bg-md-screen fixed bottom-0 left-0 w-full z-20">
                <div className="bg-white shadow-nav border-t border-black/5 rounded-t-2xl pb-[var(--safe-bottom)]">
                    <div className="flex justify-around items-stretch relative">
                        {React.Children.toArray(
                            menus.map((item) => (
                                <FooterItem
                                    role={item.role}
                                    isMain={item?.isMain}
                                    title={item?.title}
                                    icon={item?.icon}
                                    router={item?.route}
                                    isActive={pathname.includes(item.route)}
                                    main={item.main}
                                    activeIcon={item.activeIcon}
                                />
                            ))
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer
